@use '@lib/assets/styles/main.scss' as *;

.filter {
  margin-bottom: 16px;
}

.filterRow {
  align-items: center;
}

.filterColumn {
  @extend .col;
  min-width: 140px;
}

.filterTypeColumn {
  @extend .col;
}

.filterResetColumn {
  @extend .col;
  flex-grow: 1;
}

.filterDateColumn {
  @extend .col;
  width: 288px;
  box-sizing: content-box;
}
